import React from "react"
import {
  resultItem,
  resultContent,
  resultType,
  resultTypeIcon,
  resultTypeType,
  resultTitle,
  resultMore,
  resultResume,
} from "../listResults.module.scss"
import SummaryTransformer from "../../Transformers/summary-transformer"
import Icon from "../../Icon/icon"
import { summaryLength } from "../../../constants"
import TransitionFade from "../../transition-fade"
import { Article, Type, ColoredIcon } from "./result-item-styled"
import PropTypes from "prop-types"

const ResultItem = ({ result, index }) => {
  let iconType = ""
  switch (result.internal.type) {
    case "node__carnet_d_adresse":
      iconType = "address-book"
      break
    case "node__actualites":
      iconType = "newspaper"
      break
    case "node__evenements":
      iconType = "calendar"
      break
    case "node__teleformulaires":
      iconType = "profile"
      break
    default:
      iconType = "file-empty"
  }
  return (
    <li id={"item-" + index} role="option">
      <Article className={resultItem}>
        <TransitionFade link={result.path.alias}>
          <div className={resultContent}>
            <Type className={resultType}>
              <Icon className={resultTypeIcon} size={20} icon={iconType} />
              <h3 className={resultTypeType}>
                {result.relationships.node_type.name}
              </h3>
            </Type>
            <h4 className={resultTitle}>{result.title}</h4>
            {result.body && (
              <p
                className={resultResume}
                dangerouslySetInnerHTML={{
                  __html: SummaryTransformer(result.body, summaryLength),
                }}
              />
            )}
          </div>
          <div className={resultMore}>
            <ColoredIcon size={30} icon="circle-right" />
          </div>
        </TransitionFade>
      </Article>
    </li>
  )
}

ResultItem.propTypes = {
  result: PropTypes.object,
  index: PropTypes.integer,
}

export default ResultItem
